// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2K7hl","colMin":"styles_colMin__2usCv","colCheckbox":"styles_colCheckbox__2XZpq"};